module.exports = __webpack_public_path__ + "img/nathalie_cabinet_saint-cyr-lecole.ef6cf1b9.jpg";